export const THEATER = 'theater'
export const LIBRARY = 'library'
export const BIBLIOTECA = 'biblioteca'
export const SOUNDS = 'sounds'
export const SONIDOS = 'sonidos'
export const CAMINOS_BIBLIOTECA = 'caminos_biblioteca'
export const ELAR = 'elar'
export const SLAR = 'slar'

const TEACHER_GUIDE = {
  [THEATER]: THEATER,
  [LIBRARY]: LIBRARY,
  [BIBLIOTECA]: BIBLIOTECA,
  [SOUNDS]: SOUNDS,
  [SONIDOS]: SONIDOS,
  [CAMINOS_BIBLIOTECA]: CAMINOS_BIBLIOTECA,
  [ELAR]: ELAR,
  [SLAR]: SLAR,
}

export default TEACHER_GUIDE
